<template>
    <v-layout row>
        <v-dialog v-model="dialog" persistent max-width="1000px">
            <v-btn flat block slot="activator"><v-icon left>edit</v-icon>Edit</v-btn>
            <v-card>
                <form v-on:submit.prevent="create">
                    <v-card-title>
                        <span class="headline">Edit trs</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs6 s6 md6>
                                    <v-text-field
                                            v-validate="'required'"
                                            v-model="data.trs_data.trs_code"
                                            :error-messages="errors.collect('data.trs_data.trs_code')"
                                            label="Code"
                                            data-vv-name="data.trs_data.trs_code"
                                            browser-autocomplete="off"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs6 s6 md6>
                                    <v-text-field
                                            v-validate="'required'"
                                            v-model="data.trs_data.trs_description"
                                            :error-messages="errors.collect('data.trs_data.trs_description')"
                                            label="Description"
                                            data-vv-name="data.trs_data.trs_description"
                                            browser-autocomplete="off"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs6 s6 md6>
                                    <v-text-field
                                            v-validate="'required'"
                                            v-model="data.trs_data.trs_quantity"
                                            :error-messages="errors.collect('data.trs_data.trs_quantity')"
                                            label="Quantity"
                                            data-vv-name="data.trs_data.trs_quantity"
                                            browser-autocomplete="off"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs6 s6 md6>
                                    <v-text-field
                                            v-validate="'required|decimal'"
                                            v-model="data.trs_data.trs_unit_price"
                                            :error-messages="errors.collect('data.trs_data.trs_unit_price')"
                                            label="Unit price"
                                            data-vv-name="data.trs_data.trs_unit_price"
                                            browser-autocomplete="off"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs6 s6 md6>
                                    <v-text-field
                                            v-validate="'required|decimal'"
                                            v-model="data.trs_data.trs_vat"
                                            :error-messages="errors.collect('data.trs_data.trs_vat')"
                                            label="Vat"
                                            data-vv-name="data.trs_data.trs_vat"
                                            browser-autocomplete="off"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs6 s6 md6>
                                    <v-text-field
                                            v-validate="'required|decimal'"
                                            v-model="data.trs_data.trs_total_price"
                                            :error-messages="errors.collect('data.trs_data.trs_total_price')"
                                            label="Total price"
                                            data-vv-name="data.trs_data.trs_total_price"
                                            browser-autocomplete="off"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click.native="cancel()">Cancel</v-btn>
                        <v-btn color="blue darken-1" flat type="submit">Save</v-btn>
                    </v-card-actions>
                </form>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import { DICCIONARIO } from '../../../../../diccionario';

    export default {
        props: ['id', 'transport'],
        data: () => ({
            dialog: false,
            data : {
                trs_data : {
                    trs_code : '',
                    trs_description : '',
                    trs_quantity : '',
                    trs_unit_price : '',
                    trs_total_price : '',
                    trs_vat: 0
                }
            },
            types: null,
            label: 'Kg'
        }),
        created () {
            this.data.trs_data = this.transport;
        },
        mounted () {
            this.$validator.localize('en', DICCIONARIO)
        },
        methods: {
            create () {
                this.$validator.validateAll().then((result) => {
                    if(result){
                        var transport_id = this.transport.id;

                        var params = this.data.trs_data;

                        params.transport_id = transport_id;
                        params.id = this.id;

                        this.$store.dispatch('editOrderTransport', params).then((res) => {
                            this.$emit('created');
                            this.data.trs_data =  {
                                trs_code : '',
                                trs_description : '',
                                trs_quantity : '',
                                trs_unit_price : '',
                                trs_total_price : '',
                                trs_vat: 0
                            };
                            this.dialog = false
                        }).catch((error) => {

                        });
                    }
                });
            },
            cancel () {
                this.dialog = false;
                this.data.trs_data =  {
                    trs_code : '',
                    trs_description : '',
                    trs_quantity : '',
                    trs_unit_price : '',
                    trs_total_price : '',
                    trs_vat: 0
                };
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/admin/orders/views/components/EditOrderTransport.vue